import Vue from 'vue'
import Vuex from 'vuex'
import { http } from '@/utils/http'
import Storage from '@/utils/Storage'
import productList from './modules/product'
import message from './modules/message'

import areaData from '@/assets/area.js'
import { setCookie } from '../utils/tools'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userData: {
    },
    session: Storage.load("session"),
    // 教育水平
    educationMap: {
      0: '不限',
      /* 1: '小学',
      2: '初中',
      3: '高中', */
      8: '大专以下',
      4: '大专',
      5: '本科',
      6: '硕士',
      7: '博士'
    },
    // 性别
    sexMap: {
      1: '男',
      2: '女'
    },
    // 情感状态
    statusMap: {
      0: '不限',
      1: '未婚单身',
      2: '离异有子',
      3: '离异无子',
      4: '丧偶有子',
      5: '丧偶无子',
      6: '脱单恋爱中',
      7: '脱单已婚'
    },
    // 收入水平
    salaryMap: {
      0: '不限',
      1: '10w以下',
      2: '10w-20w',
      3: '20w-30w',
      4: '30w-40w',
      5: '40w-50w',
      6: '50w-60w',
      7: '60w-70w',
      //8: '70w以上'
      8: '70W-80W',
      9: '80W-120W',
      10: '120W以上'
    },
    // 车房状态
    assetsMap: {
      1: '未购车/房',
      2: '已购车',
      3: '已购房',
      4: '已购车/房'
    },
    // 星座映射
    constellationMap: {
      1: '白羊座',
      2: '金牛座',
      3: '双子座',
      4: '巨蟹座',
      5: '狮子座',
      6: '处女座',
      7: '天秤座',
      8: '天蝎座',
      9: '射手座',
      10: '摩羯座',
      11: '水瓶座',
      12: '双鱼座'
    },
    // 资料审核状态
    certStatusMap: {
      0: '待认证',
      1: '待审核',
      2: '审核不通过',
      3: '完成'
    },
    channelMap: {
      1: '朋友推荐',
      2: '公众号',
      3: '豆瓣',
      4: '知乎',
      99: '其他'
    },
    // 会员状态
    memberStatus: {
      0: '新会员',
      1: '审核通过',
      2: '审核不通过',
      3: '完成'
    },
    ifStudentMap: {
      0: '已经工作',
      1: '在校学习'
    },
    areaData: areaData
  },
  getters: {
    userId: state => state.userData.id,
    mId: state => state.userData.mid,
    session: state => state.session
  },
  mutations: {
    updateUserData (state, b) {
      state.userData = { ...state.userData, ...b }
    },
    setSession(state, session){
      state.session = session
      Storage.save('session', session)
      setCookie('session', session)
    }
  },
  actions: {
    fetchUserData ({ commit }, params) {
      return http('/api/member/myself', params, 'get').then(res => {
        let tempData = res.data
        if (res.code === '0000' && tempData) {
          Storage.save('userId', tempData.currentMemberId)
          commit('updateUserData', tempData)
        }
      })
    }
  },
  modules: {
    productList,
    message
  }
})
